
import store from '@/store'

export default{
  inserted(el, binding, vnode) {
    const { value } = binding
    const perms = store.getters && store.getters.perms

    if (value && value instanceof Array && value.length > 0) {
      const permissions = value

      const hasPermission = perms.some(perm => {
        return permissions.includes(perm)
      })

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`需要权限! 比如 v-permission="['GET /aaa','POST /bbb']"`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/permission.js